import React from "react"
import { InputLabel } from "../@citydna/common/InputLabel"
import { Box, Chip, makeStyles, Theme } from "@material-ui/core"
import { SchemaFieldDefinition, SchemaField } from "./schema"

export const fieldTypes: SchemaFieldDefinition[] = [
  {
    type: "Text field",
    template: {
      variant: "text",
      name: "",
      alias: "",
      description: "",
      required: false,
    },
  },
  {
    type: "Multiline text field",
    template: {
      variant: "multiline",
      name: "",
      alias: "",
      description: "",
      required: false,
    },
  },
  {
    type: "Markdown field",
    template: {
      variant: "markdown",
      name: "",
      alias: "",
      description: "",
      required: false,
    },
  },
  {
    type: "True/false field",
    template: {
      variant: "switch",
      name: "",
      alias: "",
      description: "",
      required: false,
    },
  },
  {
    type: "Dropdown field",
    template: {
      variant: "select",
      name: "",
      alias: "",
      description: "",
      required: false,
      domain: {
        name: "",
        type: "coded-value",
        // @ts-ignore
        codedValues: [],
      },
    },
  },
  {
    type: "Image upload field",
    template: {
      variant: "imageUpload",
      name: "",
      alias: "",
      description: "",
      required: false,
    },
  },
]

/** Scoped @material-ui/core stylesheet */
const useStyles = makeStyles<Theme>(theme => ({
  chip: {
    marginRight: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
}))

export const AddFields: React.FC<{
  append: (value: SchemaField, shouldFocus: boolean) => void
}> = ({ append }) => {
  /** Get scoped CSS classes */
  const classes = useStyles()

  return (
    <Box mb={2}>
      <InputLabel>Add fields</InputLabel>
      {fieldTypes.map(fieldType => (
        <Chip
          key={fieldType.type}
          label={fieldType.type}
          className={classes.chip}
          onClick={() => append(fieldType.template, true)}
        />
      ))}
    </Box>
  )
}
